import { render, staticRenderFns } from "./InvoicesOld.vue?vue&type=template&id=786584a6"
import script from "./InvoicesOld.vue?vue&type=script&lang=js"
export * from "./InvoicesOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports